import { render, staticRenderFns } from "./VAuctionBannerForm.vue?vue&type=template&id=08158d90"
import script from "./VAuctionBannerForm.vue?vue&type=script&lang=js"
export * from "./VAuctionBannerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports